import React, { FC } from 'react';
import { Breadcrumbs as BaseBreadcrumbs, Link, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Link as BaseLink } from 'react-router-dom';

import { BreadcrumbsLinkData } from './model/breadcrumbsModel';
import './Breadcrumbs.scss';

interface BreadcrumbsProps {
  links: BreadcrumbsLinkData[];
  title: string;
  hide?: boolean;
}

const Breadcrumbs: FC<BreadcrumbsProps> = (props) => {
  const { t } = useTranslation();

  return (
    <>
      {!props.hide && (
        <BaseBreadcrumbs aria-label="breadcrumb">
          {props.links.map(({ label, to }) => {
            if (to) {
              return (
                <Link color="inherit" to={to} key={to} component={BaseLink}>
                  {t(label)}
                </Link>
              );
            } else {
              return (
                <Typography className="text" key={label}>
                  {t(label)}
                </Typography>
              );
            }
          })}
          <Typography className="title">{t(props.title)}</Typography>
        </BaseBreadcrumbs>
      )}
    </>
  );
};

export default Breadcrumbs;
